module.exports = __webpack_public_path__ + "static/media/bayerische_small.cc543b16.png";